import React from 'react';
import { connect } from 'react-redux';
import { redirectTo } from './../../action/redirection';
import { Utils } from '../../util/utils';
import { Pages } from '../../constants/actionType'
import * as accessoriesAction from '../../action/accessoriesAction'
import { clearFilterData } from './../../action/productsAction';
import { updateSCTags, getDTMInit } from './../../service/dtmTag';
import { catchJSException } from './../../service/logService';


class Category extends React.PureComponent {

    OnClick = ((selectedPrd) => {
        try {
            // let referringUrl = window.location.href;
            // let productName = selectedPrd.name;
            // let scTagData = "category: ".concat(productName);
            // updateSCTags(scTagData);
            // let transactionData = {
            //     visitId: this.props.appState.visitId
            // }
            // getDTMInit("accessoriesCategories", productName, "", "", "", "", "", "", transactionData, referringUrl);            
            let selectedPrds = Utils.removeSpecialChars(selectedPrd.seoKw)
            let redirectURL = Pages.Category + selectedPrds + "/";
            let request = {
                //"categoryId": selectedPrd.categoryId,
                "categoryName": selectedPrd
            }
            clearFilterData(this.props.dispatch);
            accessoriesAction.storeCategoryId(this.props.dispatch, request)
            redirectTo(redirectURL, this.props.dispatch)

        } catch (ex) {
            catchJSException('category', this.props.appState.visitId, 'onClick', ex);
        }
    })

    render() {

        let categoriesList = [];
        if (this.props.categoriesValue && this.props.categoriesValue.categoriesExp && this.props.categoriesValue.categoriesExp.length) {
            this.props.categoriesValue.categoriesExp.map((categoriesExpitems, index) => (
                categoriesList.push(<li key={index}><a tabIndex="0" className="categoryList"  href={Pages.Category + Utils.removeSpecialChars(categoriesExpitems.seoKw) + "/"} lid={categoriesExpitems.name} onClick={(e) => {e.preventDefault(); this.OnClick(categoriesExpitems)}}>
                    {/* <img src={require(`../../assets/img/accessories/media/images-accessories/${categoriesExpitems.imageName}.png`)} 
                    alt={categoriesExpitems.name} /> */}
                    <div className="shelf-icon" aria-hidden="true">
                        <img  src={Utils.getImagePath(categoriesExpitems.imagePath)}
                            alt={categoriesExpitems.altText} />
                    </div>
                    <span>{categoriesExpitems.name}</span>
                </a></li>)))
        }
        return (
            <React.Fragment>
                <div className="store-front-inner">
                    <h3 className="margin-top-large">Categories</h3>
                    <div className="store-container">
                        <div className="margin-horiz-large">
                            <ul className="tiny-block-grid-2 small-block-grid-3 medium-block-grid-4 large-block-grid-6 store-icon-nav">
                                {categoriesList}
                            </ul>
                        </div>
                    </div>
                    <h3 className="headClass margin-top-large hide">Featured accessories</h3>
                </div>

            </React.Fragment>
        );
    }
}

export default connect(

)(Category);